import * as React from 'react';
import { useParams } from 'react-router-dom';
import { PaymentIn } from 'cb-model';
import { Display, NavIconContainer, PageTitle, QuerySingle, Section } from 'gossamer-front-end';

/**
 * PaymentIn Display Page
 *
 * Display details for a single inbound payment record (read-only)
 */
export const PaymentInDisplay = (): React.JSX.Element => {
  const params = useParams();

  return (
    <>
      <NavIconContainer entityId={PaymentIn.id} />
      <PageTitle verb="Display" entity={PaymentIn} keyValue={params.key} />

      <Section>
        <QuerySingle entity={PaymentIn} keyValue={params.key} render={Display} />
      </Section>
    </>
  );
};
